import { Card } from "@material-ui/core";
import React from "react";
import "./Github.css";
import Githubcalendar from "react-github-calendar";
import { ThemeContext } from "../../Context/theme";
import { GithubStats } from "./GithubStats";


export const Github = () => {
  const colourTheme = {
    background: "transparent",
    text: "#ffffff",
    grade4: "#8400b8",
    grade3: "#b22ff4",
    grade2: "#b265f6",
    grade1: "#c084f5",
    grade0: "#ecd9fc"
  };
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <div className={"section " + themename} data-aos="fade-right">
        <h2 className="section__title different">
          Days I <span className="different"> Code</span>
        </h2>
        <Githubcalendar
          class="react-activity-calendar"
          username="vivekbtu"
          blockSize={15}
          blockMargin={5}
          // theme={themename}
          fontSize={14}
        />
      </div>

      <div className={"section " + themename} data-aos="fade-right" >
        {/* <picture className="gitstats">
        <source 
          srcset="https://github-readme-stats.vercel.app/api?username=vivekbtu&show_icons=true&theme=dark"
          media="(prefers-color-scheme: dark)"
        />
        <source 
          srcset="https://github-readme-stats.vercel.app/api?username=vivekbtu&show_icons=true"
          media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
        />
        <img className="gitstats" src="https://github-readme-stats.vercel.app/api?username=vivekbtu&show_icons=true" />
      </picture> */}

      <GithubStats/>
      </div>

      
    </>
  );
};
